import { useCallback } from 'react';

import * as styles from './research-area-picker.css';

export const RESEARCH_AREAS = [
  'Molecular Biology',
  'Cell Biology',
  'Genetics & Genomics',
  'Biochemistry',
  'Structural Biology',
  'Neuroscience',
  'Immunology',
  'Microbiology',
  'Virology',
  'Pharmacology',
  'Drug Discovery',
  'Clinical Research',
  'Bioinformatics',
  'Cancer Biology',
  'Developmental Biology',
] as const;

export type ResearchArea = (typeof RESEARCH_AREAS)[number];

export const ResearchAreaPicker = ({
  value,
  onChange,
}: {
  value: string[];
  onChange: (next: string[]) => void;
}) => {
  const toggle = useCallback(
    (area: string) => {
      onChange(
        value.includes(area)
          ? value.filter(a => a !== area)
          : [...value, area]
      );
    },
    [value, onChange]
  );

  return (
    <div className={styles.container}>
      {RESEARCH_AREAS.map(area => (
        <button
          type="button"
          key={area}
          className={styles.chip}
          data-selected={value.includes(area)}
          onClick={() => toggle(area)}
        >
          {area}
        </button>
      ))}
    </div>
  );
};
